const accordionWrapper = [
  ...document.querySelectorAll('.paragraph--accordion'),
];
const accordionContent = '.accordion__content';
const accordionOpenClass = 'accordion--open';

const closeAccordion = (accordion, content) => {
  accordion.classList.remove(accordionOpenClass);
  content.style.height = '0px';
};

const toggleAccordion = () => {
  accordionWrapper.forEach((accordionItem) => {
    const accordions = [...accordionItem.querySelectorAll('.accordion')];

    accordions.forEach((accordion) => {
      const heading = accordion.querySelector('.accordion__header');

      heading.addEventListener('click', () => {
        const isOpen = accordion.classList.contains(accordionOpenClass);
        const content = accordion.querySelector(accordionContent);

        if (!isOpen) {
          // eslint-disable-next-line max-nested-callbacks
          accordions.forEach((acc) => {
            closeAccordion(acc, acc.querySelector(accordionContent));
          });

          accordion.classList.add(accordionOpenClass);
          content.style.height = `${content.scrollHeight}px`;
        } else {
          closeAccordion(accordion, content);
        }
      });
    });
  });
};

(() => {
  if (accordionWrapper.length > 0) toggleAccordion();
})();
